// Opening an item from inside a folder puts that folder's id on the item's URL, so the detail
// page's back link can return to the level the user came from instead of dumping them at the top
// of the index. The id on its own is enough: the index rebuilds the whole breadcrumb from it, so a
// report sitting three folders deep comes back to the folder it was in, not to "All Items".
//
// It lives in the URL rather than in router state so a refresh, a new tab, or a shared link keeps
// the same trail.
import { useSearchParams } from 'react-router-dom'

export const FOLDER_PARAM = 'folder_id'

// Adds the folder to an item's path, keeping any query string the path already carries — a view's
// path is `/dashboards/<section>?dashboard_id=…`.
export const withFolderContext = (path, folderId) => {
  if (!path || !folderId) return path
  const separator = path.includes('?') ? '&' : '?'
  return `${path}${separator}${FOLDER_PARAM}=${encodeURIComponent(folderId)}`
}

// Where a detail page's back link goes: the folder the item was opened from, or the index itself.
export const folderReturnPath = (folderId) =>
  folderId ? `/dashboards?${FOLDER_PARAM}=${encodeURIComponent(folderId)}` : '/dashboards'

// PageTitle's breadcrumbs take a path without the leading slash — it adds one.
export const folderReturnCrumbUrl = (folderId) => folderReturnPath(folderId).slice(1)

// The folder the current page was opened from, if any.
export const useFolderContext = () => {
  const [searchParams] = useSearchParams()
  return searchParams.get(FOLDER_PARAM)
}

export const useFolderReturnPath = () => folderReturnPath(useFolderContext())
